import store, { modulesName } from '@/store';

export const userMixin = {
  computed: {
    currentAcademicYearId() {
      return store.getters[
        `${modulesName.commonModuleName}/currentAcademicYear`
      ]?.data?.id;
    },
    currentAcademicYearInfo() {
      return store.getters[
        `${modulesName.commonModuleName}/currentAcademicYear`
      ]?.data;
    },
    userAuthenticated() {
      return store.getters[`${modulesName.userModuleName}/authenticated`];
    },
    userRole() {
      return store.getters[`${modulesName.userModuleName}/role`];
    },
    userRoleId() {
      return store.getters[
        `${modulesName.userModuleName}/roleId`
      ].toUpperCase();
    },
    userCompanies() {
      return store.getters[`${modulesName.userModuleName}/companies`];
    },
    userMainCompany() {
      return store.getters[`${modulesName.userModuleName}/mainCompany`];
    },
    userProfile() {
      let profile = store.getters['$_user/fullProfile'];
      return profile;
    },
  },
  methods: {
    userHasPermissions(...permissions) {
      return store.getters[`${modulesName.userModuleName}/hasPermissions`](
        permissions
      );
    },
    disposeStoreModule(moduleName) {
      if (moduleName) {
        this.$store.unregisterModule(moduleName);
        sessionStorage.removeItem(moduleName);
      }
    },
  },
};
